import React, { useEffect, useState } from "react";
import "./Review.css";
import quoteImg from "./../../images/right-quote.png";
import profileImg from "./../../images/profile.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import SwiperCore, {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  EffectCoverflow,
} from "swiper";
import axios from "axios";

SwiperCore.use([
  Autoplay,
  EffectCoverflow,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
]);

const Review = () => {
  const [reviewData, setReviewData] = useState([]);

  useEffect(() => {
    axios
      .get("https://mysterious-sierra-48850.herokuapp.com/get-approved-review")
      .then((data) => {
        console.log(data.data);
        setReviewData(data.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, []);

  return (
    <section className="review_section container-fluid">
      {reviewData.length === 0 ? (
        <h1 className="text-center">Loading...</h1>
      ) : (
        <>
          <h3 className="brand_text mt-4">What Our Client Say</h3>
          <div className="container-fluid">
            <Swiper
              effect="coverflow"
              grabCursor={true}
              spaceBetween={160}
              slidesPerView="auto"
              loop={true}
              navigation
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              effectCoverflow={{
                rotate: 150,
                stretch: 0,
                depth: 100,
                modifier: 2,
                slideShadows: true,
              }}
              pagination={{ clickable: true }}
              // onSlideChange={() => console.log("slide change")}
              // onSwiper={(swiper) => console.log(swiper)}
            >
              {reviewData.length &&
                reviewData.map((review, i) => {
                  return (
                    <SwiperSlide key={i}>
                      <div className="testimonialBox">
                        <img
                          src={quoteImg}
                          width="50px"
                          alt="quote"
                          className="quote"
                        />
                        <div className="testimonialContent">
                          <p>{review?.review}</p>
                          <div className="details">
                            <div className="imgBx">
                              <img src={profileImg} alt="user" />
                            </div>
                            <h3>
                              {review?.name}
                              <br />
                              <span>{review?.star}</span>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>
        </>
      )}
    </section>
  );
};

export default Review;
